module.exports = __webpack_public_path__ + "img/in_progress_delivery.8e818578.svg";